module.exports = __webpack_public_path__ + "img/fi_logo.904589f.png";